import { Toastertype } from '@/queue/types';
import * as React from 'react';
import { toast } from "react-toastify";

const ClickableToastMessage = ({ message, onClickOnAction, buttonLabel, hideActionBtn }: any) => {
    return (<div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <p className="toast-msg" >{message}</p>
        {
            !hideActionBtn &&  <p className="toast-msg toast-msg__action-btn" style={{ color: "#0090C6", textDecoration: 'underline', marginRight: '0.5rem' }} onClick={() => {
                onClickOnAction();
            }}>{buttonLabel ? buttonLabel : "View the transfer details"}</p>
        }
    </div>)
};
const SimpleToastMessage = ({ message }: any) => {
    return (
        <div style={{ display: 'flex', justifyContent: 'space-between', width: 'fit-content' }}>
            <p className="toast-msg" >{message}</p>
        </div>
    )
};
export const OutlineToasterNotification = (type: Toastertype, message: string, onClickOnAction: () => void, buttonLabel?: string, hideActionBtn = false) => {
        return toast[type](<ClickableToastMessage buttonLabel={buttonLabel} hideActionBtn={hideActionBtn} message={message} onClickOnAction={onClickOnAction} />, {
            position: toast.POSITION.BOTTOM_CENTER,
            className: type === Toastertype.error ? "red-outline" : "green-outline",
            hideProgressBar: true,
            icon: ({ theme, type }) => type === Toastertype.error ? <img src="/images/ui/error.svg" /> : <img src="/images/ui/checkmark.svg" />,
        });
};

export const SimpleToasterNotification = (type: any, message: string) => {
    if (type == "success")
        return toast.success(<SimpleToastMessage message={message} />, {
            position: toast.POSITION.BOTTOM_CENTER,
            className: "green-outline",
            hideProgressBar: true,
        });
};

const ErrorToastMessage = ({ message }: any) => {
    return (<div style={{ display: 'flex', justifyContent: 'space-between', marginRight: '0.5rem' }}>
        <p className="toast-msg" >{message}</p>
    </div>)
};

export const ErrorToasterNotification = (message: string) => {
    return toast.success(<ErrorToastMessage message={message} />, {
        position: toast.POSITION.BOTTOM_CENTER,
        className: "error-outline",
        hideProgressBar: true,
        icon: ({ theme, type }) => <img className='error-icon' src="/images/ui/fail.svg" />,
    });
};
